<template>
  <main class="monitoring-main">
    <sectionHeader class="section-header-monitoring" title="Transfers">
      <template #action>
        <ElDropdown
          trigger="click"
          style="margin-left: 15px"
          placement="bottom-end"
          @command="handleCommand"
        >
          <button
            class="btn-border btn--round l-flex-row l-align-center"
            style="height: 32px; padding: 0 8px;"
          >
            Transfer actions
            <svg-icon
              class="sub-navigation-cta-icon is-white"
              name="dots"
              size="small"
              style="margin-right: -5px;"
            />
          </button>

          <ElDropdownMenu slot="dropdown">
            <ElDropdownItem
              command="transfer_export"
              class="l-flex-row dropdown-menu-action"
            >
              <span>Transfers export</span>
            </ElDropdownItem>

            <template v-if="selectedTransferRowId && monitoringActionAllowed">
              <ElDropdownItem divided />
              <ElDropdownItem
                command="delete"
                class="l-flex-row dropdown-menu-action"
              >
                <span>Delete</span>
              </ElDropdownItem>
            </template>
          </ElDropdownMenu>
        </ElDropdown>
      </template>
    </sectionHeader>
    <!-- Table -->
    <div class="no-results" v-if="transferList.length === 0">
      No results found
    </div>
    <template v-else>
      <div class="section-search-update-delete" :class="{ 'edit-delete-is-allowed': monitoringActionAllowed }">
        <el-tooltip
          content="Quota reached. You can edit or delete up to 100 transfers at time."
          placement="top"
          :disabled="bulkSelectedRows.length <= 100"
          v-if="monitoringActionAllowed"
        >
          <div
            class="l-flex-row bulk-actions"
            v-if="monitoringActionAllowed"
          >
            <svg-icon
              class="cursor"
              title="edit rows"
              name="edit"
              size="medium"
              :disabled="bulkSelectedRows.length < 1 || bulkSelectedRows.length > 100"
              @click.native="displayBulkEditForm(true, false)"
            />
            <svg-icon
              class="cursor"
              title="delete rows"
              name="trash"
              size="medium"
              :disabled="bulkSelectedRows.length < 1 || bulkSelectedRows.length > 100"
              @click.native="displayBulkEditForm(true, true)"
            />
          </div>
        </el-tooltip>
        <div class="dashboard-search-wrapper">
          <Search
            :query="queryFilter"
            :query-type="queryTypeFilter"
            :types="searchTypes"
            :sort-by-score="false"
            all-type-search
            @queryChange="queryFilter = $event"
            @queryTypeChange="queryTypeFilter = $event"
            @filterChange="handleFilterQueryChange"
            @reset="componentHandleQueryReset"
          />

          <div class="filters-wrapper" style="margin-left: 15px">
            <button
              class="btn-simple small btn-table-filters"
              :class="{ 'is-highlighted': showFilters }"
              title="Display filters"
              @click="toggleFilter"
            >
              <svg-icon name="filter" size="small" />
            </button>
          </div>
        </div>
      </div>
      <div class="filters-wrapper-list l-flex" v-show="showFilters">
        <div class="filters-wrapper-list_top">
          <div class="l-flex-row filter-item filter-status filter-item-wrapper">
            <div class="filter-label">
              <svg-icon name="filter" size="small" />
              <SelectFilter
                v-model="statusFilter"
                property="status"
                label="Status"
                :options="[
                  { key: 'active', label: 'Active' },
                  { key: 'inactive', label: 'Inactive' }
                ]"
                @filterChange="handleFilterFnChange('statusFilterFn', $event)"
              />
            </div>
          </div>

          <div class="l-flex-row filter-item filter-status filter-item-wrapper">
            <div class="filter-label">
              <svg-icon name="bootstrap" size="small" />
              <SelectFilter
                v-model="bootstrapFilter"
                property="bootstrap_status"
                label="Push of stock"
                :options="[
                  { key: 'not_applicable', label: 'Not Applicable' },
                  { key: 'pending', label: 'Pending' },
                  { key: 'delivered', label: 'Delivered' },
                  { key: 'processing', label: 'Processing' },
                  { key: 'failed', label: 'Failed' },
                ]"
                @filterChange="handleFilterFnChange('bootstrapFilterFn', $event)"
              />
            </div>
          </div>
        </div>

        <div class="filters-wrapper-list_btm">
          <div
            class="filter-item-wrapper l-flex-row"
            v-for="dateFilter in dateFilters"
            :key="dateFilter.key"
          >
            <div class="filter-item filter-date">
              <div class="filter-label">
                <svg-icon
                  :name="dateFilter.icon.name"
                  :size="dateFilter.icon.size"
                />
                <div class="filter-text">
                  {{ dateFilter.from.label }}
                </div>
              </div>

              <div class="filter-date-combo l-flex-row">
                <select
                  class="select-operator"
                  v-model="operators[dateFilter.key]"
                  @change="changeOperator(dateFilter.key)"
                >
                  <option
                    v-for="operator in filterDateOperators"
                    :key="operator.value"
                    :value="operator.value"
                  >
                    {{ operator.label }}
                  </option>
                </select>

                <el-date-picker
                  type="date"
                  v-model="dateFiltersVModelFromValues[dateFilter.key]"
                  :placeholder="dateFilter.from.placeholder"
                  @change="handleFromDate(dateFilter.key, $event)"
                  :picker-options="{
                    disabledDate: (time) =>
                      disabledpickerOptionsFromDate(time, dateFilter.key)
                  }"
                />

                <div class="filter-date-to" v-if="displayTo[dateFilter.key]">
                  <div class="filter-text-to">
                    {{ dateFilter.to.label }}
                  </div>
                  <el-date-picker
                    v-model="dateFiltersVModelToValues[dateFilter.key]"
                    type="date"
                    :placeholder="dateFilter.to.placeholder"
                    @change="handleToDate(dateFilter.key, $event)"
                    :picker-options="{
                      disabledDate: (time) =>
                        disabledpickerOptionsToDate(time, dateFilter.key)
                    }"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="filters-wrapper-list_btm">
          <div
            class="filter-item filter-status filter-item-wrapper l-flex-row"
            style="width: 96%"
          >
            <div class="filter-item filter-status" style="margin-right: 15px">
              <div class="filter-label">
                <svg-icon name="filter" size="small" />
                <div class="filter-text" style="white-space: nowrap;">
                  Partners
                </div>
              </div>
              <el-select
                class="filter-partners no-media-query"
                v-model="partnersValue"
                multiple
                filterable
                default-first-option
                collapse-tags
                placeholder="Filter by partners"
              >
                <el-option
                  v-for="item in partnerList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                />
              </el-select>
            </div>

            <div class="filter-item filter-status" style="margin-right: 15px">
              <div class="filter-label">
                <svg-icon name="filter" size="small" />
                <div class="filter-text" style="white-space: nowrap;">
                  Audience label
                </div>
              </div>
              <el-input
                class="filter-partners no-media-query"
                v-model="audienceLabelValue"
                placeholder="Filter by audience label"
              />
            </div>

            <div class="filter-item filter-status" style="margin-right: 15px">
              <div class="filter-label">
                <svg-icon name="filter" size="small" />
                <div class="filter-text" style="white-space: nowrap;">
                  Audience ID
                </div>
              </div>
              <el-input
                class="filter-partners no-media-query"
                v-model="audienceIdValue"
                placeholder="Filter by audience id"
              />
            </div>

            <div class="filter-item filter-status" style="margin-right: 15px">
              <div class="filter-label">
                <svg-icon name="filter" size="small" />
                <div class="filter-text" style="white-space: nowrap;">
                  Reference ID
                </div>
              </div>
              <el-input
                class="filter-partners no-media-query"
                v-model="referenceIdValue"
                placeholder="Filter by transfer's reference id"
              />
            </div>

            <div class="filter-item search-filters-reset" @click="resetFilters()">
              <svg-icon
                name="reload"
                size="small"
                title="reset filters"
                @click="resetFilters()"
              />
            </div>
          </div>
        </div>
      </div>
      <ElTable
        class="dashboard-table monitoring-table cursor"
        :data="paginatedData"
        v-loading="isLoading"
        ref="tableData"
        row-key="id"
        header-row-class-name="dashboard-table-header-row"
        header-cell-class-name="dashboard-table-header-cell"
        cell-class-name="dashboard-tb-cell"
        empty-text="No transfers available"
        :max-height="tableMaxHeight"
        :default-sort="{ order: sortOrder, prop: sortBy }"
        :row-class-name="rowStyle"
        :class="{'table-is-empty' : paginatedData.length === 0, 'is-shrinked': showFilters}"
        @sort-change="componentHandleSortChange"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
      >
        <ElTableColumn type="selection" width="40" reserve-selection />

        <ElTableColumn label="Id" prop="id" width="80" :sort-method="sortColumnBy('id')" sortable />
        <ElTableColumn
          label="Label"
          class-name="ft-w-med word-break-normal"
          prop="label"
          :sort-method="sortColumnBy('label')"
          sortable
        >
          <template #default="scope">
            <div class="full-width">
              <div class="l-flex-row l-align-center">
                <div
                  class="row-item-status"
                  :class="scope.row.status === 'inactive' ? 'item-inactive' : 'item-active'"
                />
                <div class="is-truncate" :title="scope.row.label">
                  {{ scope.row.label }}
                </div>
              </div>
            </div>
          </template>
        </ElTableColumn>
        <ElTableColumn label="Partner" prop="partner" :sort-method="sortColumnBy('partner')" sortable>
          <template #default="scope">
            <div class="is-truncate" :title="scope.row.partner">
              {{ scope.row.partner }}
            </div>
            <ElTooltip v-if="hasCpmOrReferenceId(scope.row)" placement="top">
              <template #content>
                <ul class="tooltip-list">
                  <li v-if="hasCpm(scope.row)">
                    <strong>CPM :</strong> {{ scope.row.cpm }}
                  </li>
                  <li v-if="hasReferenceId(scope.row)">
                    <strong>Reference ID :</strong> {{ scope.row.reference_id }}
                  </li>
                </ul>
              </template>
              <ElTag style="padding-top: 5px;margin-left: 5px" type="info" effect="plain" size="small">
                <svg-icon name="info" />
              </ElTag>
            </ElTooltip>
          </template>
        </ElTableColumn>
        <ElTableColumn label="Partner Configuration" min-width="120" prop="partnerConfiguration" :sort-method="sortColumnBy('partnerConfiguration')" sortable>
          <template #default="scope">
            <div class="is-truncate" :title="scope.row.partnerConfiguration">
              {{ scope.row.partnerConfiguration }}
            </div>
          </template>
        </ElTableColumn>
        <ElTableColumn label="Added on" prop="createdAt" :sort-method="sortColumnBy('createdAt')" sortable>
          <template #default="scope">
            <div class="is-truncate" :title="scope.row.createdAt">
              {{ scope.row.createdAt }}
            </div>
          </template>
        </ElTableColumn>
        <ElTableColumn label="End Date" prop="endDate" :sort-method="sortColumnBy('endDate')" sortable />
        <ElTableColumn label="Push of stock" prop="bootstrap_status" :sort-method="sortColumnBy('bootstrap_status')" sortable>
          <template #default="scope">
            <div class="is-truncate" :title="scope.row.bootstrap_status">
              {{ scope.row.bootstrap_status }}
            </div>
          </template>
        </ElTableColumn>
      </ElTable>
      <ElPagination
        background
        layout="prev, pager, next, sizes"
        :total="filteredData.length"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 25, 50, 100]"
      />
      <div
        class="overlay-close"
        v-if="displayModal.bulkEdit"
        @click="displayBulkEditForm(false)"
      />
      <div
        class="modal modal-h-medium modal-form-audience"
        v-if="displayModal.bulkEdit"
        :class="{ 'disabled': isUpdatedOrDeletedLoading }"
      >
        <BulkEditForm
          :bulk-list="bulkSelectedRows"
          @bulkEditFinished="clearSelection()"
          :is-delete="isDeleteForm"
        />
      </div>
    </template>
  </main>
</template>


<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import { cloneDeep, isEmpty, isNil } from 'lodash'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

import { AUDIENCES_FILTERS_PROPS, FILTER_DATE_OPERATORS, FILTERING_DEFAULT_DATES } from '@/utils/constants'

import BulkEditForm from '@/components/monitoring-transfers/BulkEditForm'
import Search from '@/components/common/Search'
import SelectFilter from '@/components/common/SelectFilter'
import SectionHeader from '@/components/common/SectionHeader'

import tablePaginationMixin from '@/mixins/tablePaginationMixin'
import tableOrderMixin from '@/mixins/tableOrderMixin'

import { formatDate } from '@/utils/helpers'

export default {
    mixins: [tablePaginationMixin, tableOrderMixin],

    components: {
        SectionHeader,
        Search,
        SelectFilter,
        BulkEditForm
    },

    mounted() {
        this.dateFilters = [
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterStartDate),
                key: 'filterStartDate',
                from: { label: 'Start', placeholder: this.createdOrStartDateFromDefaultValue, pickerOptions: this.pickerOptionsStartOrCreatedFrom },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: this.pickerOptionsStartOrCreatedTo }
            },
            {
                icon: { name: 'calendar', size: 'small' },
                dates: cloneDeep(this.filterEndDate),
                key: 'filterEndDate',
                from: { label: 'End', placeholder: this.newDate, pickerOptions: null },
                to: { label: 'to', placeholder: this.newDate, pickerOptions: this.pickerOptionsEndTo }
            }
        ]
        window.addEventListener('resize', () => {
            this.windowHeight = window.innerHeight
        })
    },

    watch: {
        activeTransfers: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if(newValue) {
                    this.resetFilters()
                    this.statusFilter = 'active'
                    this.showFilters = newValue
                }
            }
        },
        isExpiringTransfers: {
            immediate: true,
            deep: true,
            handler: function(newValue) {
                if(newValue) {
                    this.resetFilters()
                    this.operators['filterEndDate'] = 'period'
                    const thirtyDaysFromNow = dayjs().toDate()
                    const thirtyDaysToNow = dayjs().add(30, 'day').toDate()
                    this.operators['filterEndDate'] = 'period'
                    this.dateFiltersVModelFromValues = {
                        filterEndDate: thirtyDaysFromNow,
                    }
                    this.dateFiltersVModelToValues = {
                        filterEndDate: thirtyDaysToNow,
                    }
                    this.statusFilter = 'active'
                    this.showFilters = newValue
                }
            }
        },
        changeRowData: {
            async handler(value) {
                if (value && value.id && this.bulkSelectedRows.length > 0) {
                    let selected = await this.bulkSelectedRows.find(selected => selected.id === value.id)
                    if (selected) selected = Object.assign(selected, value)
                    this.setChangeRowData(null)
                }
            },
            deep: true
        },

        resetBulkSelectedRows: {
            handler: function(newValue) {
                if (newValue && this.bulkSelectedRows.length > 0) {
                    this.bulkSelectedRows = []
                    this.clearSelection()
                }
            }
        },
        updatedBulkList(values) {
            const cloned = cloneDeep(values)
            this.updateBulkListState(cloned)
        }
    },

    data() {
        return {
            //ACTIONS
            actions: {
                updateFilteredData: async items => await this.setFilteredData({ items }),
            },
            infos: {},
            // FILTERS
            filtersData: {
                filters: cloneDeep(AUDIENCES_FILTERS_PROPS),
                filterTargets: { bootstrap: '', status: '' }
            },

            // DATE FILTERS
            dateFilters: [],
            filterDateOperators: FILTER_DATE_OPERATORS,
            filterStartDate: cloneDeep(FILTERING_DEFAULT_DATES.start),
            filterEndDate: cloneDeep(FILTERING_DEFAULT_DATES.end),
            defaultDates: cloneDeep(FILTERING_DEFAULT_DATES),

            // Table utils
            defaultSortBy: 'id',
            secondSortBy: 'createdAt',
            sortBy: 'id',
            queryFilter: '',
            queryTypeFilter: null,
            searchTypes: { id: 'id', label: 'label' },
            queryFilterFn: data => data,
            showFilters: false,
            statusFilter: null,
            statusFilterFn: () => true,
            bootstrapFilter: null,
            bootstrapFilterFn: () => true,
            partnersValue: null,
            audienceLabelValue: null,
            audienceIdValue: null,
            referenceIdValue: null,
            operators: {
                filterEndDate: 'equal',
                filterStartDate: 'equal'
            },
            dateFiltersVModelFromValues: {},
            dateFiltersVModelToValues: {},
            bulkSelectedRows: [],
            isDeleteForm: false,
            showFilterOnce: false,
            showFilterPartnerWhenEmpty: false,
            windowHeight: window.innerHeight,
        }
    },

    computed: {
        ...mapState('data/transfer', {
            transfers: state => state.list,
            transferList: state => state.transferList,
            isLoading: state => state.isLoading,
            resetBulkSelectedRows: state => state.resetBulkSelectedRows,
            isUpdatedOrDeletedLoading: state => state.isUpdatedOrDeletedLoading,
            updatedBulkList: state => state.updatedBulkList
        }),
        ...mapState('dashboardAccount', {
            activeTransfers: state => {
                return state.activeTransfers
            },
            isExpiringTransfers: state => {
                return state.isExpiringTransfers
            }
        }),
        ...mapState('data/dsp', {
            dspList: state => state.list
        }),
        ...mapState('ui/transfers', {
            selectedTransferRowId: state => state.selectedTransferRowId,
            displayModal: state => state.displayModal,
        }),
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),

        // DATE FILTERS
        newDate() {
            return formatDate(new Date())
        },
        createdOrStartDateFromDefaultValue() {
            return formatDate(dayjs(this.newDate))
        },
        pickerOptionsStartOrCreatedFrom() {
            return {
                disabledDate(time) {
                    return time ? time.getTime() > Date.now() : null
                }
            }
        },
        pickerOptionsStartOrCreatedTo() {
            const _filterStartDate = this.filterStartDate
            return {
                disabledDate(time) {
                    return time && _filterStartDate.from ? time.getTime() > Date.now() || time.getTime() < _filterStartDate.from.getTime() : null
                }
            }
        },
        pickerOptionsEndTo() {
            const _filterEndDate = this.filterEndDate
            return {
                disabledDate(time) {
                    return time && _filterEndDate.from ? time.getTime() < _filterEndDate.from.getTime() : null
                }
            }
        },
        displayTo() {
            return {
                filterStartDate: this.operators.filterStartDate === 'period',
                filterEndDate: this.operators.filterEndDate === 'period'
            }
        },

        //Table
        filteredData() {
            let filteredData = this.transferList
            if (!isNil(this.queryFilter) && !isEmpty(this.queryFilter?.trim())) {
                filteredData = filteredData.filter(item => {
                    let condition = false
                    if (this.queryTypeFilter === null || this.queryTypeFilter === 'label') {
                        condition = condition || item?.label?.toLowerCase().includes(this.queryFilter?.toLowerCase())
                    }

                    if (this.queryTypeFilter === null) {
                        condition = condition || (item?.id && `${item.id}`.includes(this.queryFilter))
                    } else if (this.queryTypeFilter === 'id') {
                        condition = condition || (item?.id && `${item.id}`.startsWith(this.queryFilter))
                    }

                    this.setActiveTransfers(false)
                    this.setIsExpiringTransfers(false)
                    return condition
                })
            }

            this.setActiveTransfers(false)
            this.setIsExpiringTransfers(false)
            return filteredData
                .filter(item => this.statusFilterFn(item))
                .filter(item => this.bootstrapFilterFn(item))
                .filter(item => this.partnersFilterFn(item))
                .filter(item => this.audienceIdFilter(item))
                .filter(item => this.audienceLabelFilter(item))
                .filter(item => this.referenceIdFilter(item))
                .filter(item => this.dateFiltersFn(item))
        },
        sortedData() {
            const rows = [...this.filteredData]
            return rows.sort(this.sortColumnBy(this.sortBy))
        },
        paginatedData() {
            return this.paginate(this.sortedData)
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        },

        tableMaxHeight() {
            const height = this.showFilters ? this.windowHeight - 445 : this.windowHeight - 280
            return `${height}px`
        },
        partnerList() {
            const partners = []
            this.dspList.forEach(partner => {
                partners.push({
                    label: partner.label,
                    value: partner.keyLabel
                })
            })
            return [...partners, { value: 'Pixel URL', label: 'Pixel URL' }]
        },
    },

    methods: {
        ...mapMutations('ui/transfers', [
            'setSelectedTransferRowId',
            'setActiveTab',
            'setFilteredData',
            'setDisplayModal',
            'setDeletedTransfer'
        ]),
        ...mapActions('data/transfer', ['resetEditBulkForm']),
        ...mapMutations('data/transfer', ['setTransferInfos', 'setResetBulkSelectedRows']),
        ...mapMutations('exports', ['setExportForm']),
        ...mapMutations('dashboardAccount', ['setActiveTransfers', 'setIsExpiringTransfers']),

        formatDate(date) {
            return formatDate(date)
        },

        updateDate(key, target, value) {
            if (key === 'filterStartDate') {
                this.filterStartDate[target] = value
            } else if (key === 'filterEndDate') {
                this.filterEndDate[target] = value
            }
        },

        handleRowClick(row) {
            const selectedId = this.selectedTransferRowId !== row.id ? row.id : null
            this.setSelectedTransferRowId(selectedId)
            this.setTransferInfos(selectedId)
            this.setActiveTab({ tab: 'information' })
        },

        rowStyle({ row }) {
            if (row.id !== this.selectedTransferRowId) return
            return 'selected-row-monitoring'
        },

        componentHandleSortChange(params) {
            this.currentPage = 1
            this.handleSortChange(params)
        },

        async handleFilterQueryChange({ fn }) {
            await this.$nextTick()
            this.queryFilterFn = fn
        },

        async componentHandleQueryReset() {
            await this.$nextTick()
            this.handleQueryReset(this.$refs.tableData)
        },

        async handleFilterFnChange(fn, value) {
            if (this.showFilterOnce) await this.setSelectedTransferRowId(null)
            await this.$nextTick()
            this.currentPage = 1
            this[fn] = value
            this.showFilterOnce = true
        },

        partnersFilterFn(value) {
            if (!isEmpty(this.partnersValue)) {
                this.showFilterPartnerWhenEmpty = true
                this.setSelectedTransferRowId(null)
                return this.partnersValue.includes(value.partner) || (this.partnersValue.includes('Pixel URL') && !isEmpty(value.pixel_url))
            }
            if (isEmpty(this.partnersValue) && this.showFilterPartnerWhenEmpty) {
                this.showFilterPartnerWhenEmpty = false
                this.setSelectedTransferRowId(null)
            }
            return true
        },

        audienceIdFilter(value) {
            if (!isEmpty(this.audienceIdValue)) {
                this.setSelectedTransferRowId(null)
                return value.audience_id.trim().includes(this.audienceIdValue.trim())
            }
            return true
        },

        audienceLabelFilter(value) {
            if (!isEmpty(this.audienceLabelValue)) {
                this.setSelectedTransferRowId(null)
                return value.audienceLabel.trim().toLowerCase().includes(this.audienceLabelValue.trim().toLowerCase())
            }
            return true
        },

        referenceIdFilter(value) {
            if (!isEmpty(this.referenceIdValue)) {
                this.setSelectedTransferRowId(null)
                return value.reference_id.trim().toLowerCase().includes(this.referenceIdValue.trim().toLowerCase())
            }
            return true
        },

        dateFiltersFn(value) {
            const keyStart = 'Start'
            const keyEnd = 'End'
            const createdDate = this.defaultDates.created
            const startDate = {
                from: this.dateFiltersVModelFromValues.filterStartDate,
                to: this.dateFiltersVModelToValues.filterStartDate,
                operator: this.operators.filterStartDate
            }
            const endDate = {
                from: this.dateFiltersVModelFromValues.filterEndDate,
                to: this.dateFiltersVModelToValues.filterEndDate,
                operator: this.operators.filterEndDate
            }

            // filter on date created
            if (!isNil(createdDate.from)) {
                const _dateKey = 'created_at'
                const createdDateFrom = formatDate(createdDate.from)
                const createdDateTo = formatDate(createdDate.to)

                if (createdDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(createdDateFrom, 'day')) {
                    return false
                } else if (createdDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(createdDateFrom, 'day')) {
                    return false
                } else if (
                    (createdDate.operator === 'after' || createdDate.operator === 'period') &&
                    !dayjs(value[_dateKey]).isBetween(createdDateFrom, createdDateTo, 'day', [])
                ) {
                    return false
                }
            }
            // filter on dates start/activation
            if (!isNil(startDate.from)) {
                const _dateKey = keyStart === 'Activation' ? 'start_date' : 'createdAt'

                const startDateFrom = formatDate(startDate.from)
                const startDateTo = formatDate(startDate.to)

                if (startDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(startDateFrom, 'day')) {
                    return false
                } else if (startDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(startDateFrom, 'day')) {
                    return false
                } else if (startDate.operator === 'after' && !dayjs(value[_dateKey]).isSameOrAfter(startDateFrom, 'day')) {
                    return false
                } else if (
                    (startDate.operator === 'after' || startDate.operator === 'period') &&
                    !dayjs(value[_dateKey]).isBetween(startDateFrom, startDateTo, 'day', [])
                ) {
                    return false
                }
            }
            // check on end or update date according to key param
            if (!isNil(endDate.from)) {
                const _dateKey = keyEnd === 'Update' ? 'updatedAt' : 'endDate'
                const endDateFrom = formatDate(endDate.from)
                const endDateTo = formatDate(endDate.to)

                if (endDate.operator === 'equal' && !dayjs(value[_dateKey]).isSame(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'before' && !dayjs(value[_dateKey]).isSameOrBefore(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'after' && !dayjs(value[_dateKey]).isSameOrAfter(endDateFrom, 'day')) {
                    return false
                } else if (endDate.operator === 'period' && !isNil(endDate.to) && !dayjs(value[_dateKey]).isBetween(endDateFrom, endDateTo, 'day', [])) {
                    return false
                }
            }
            return true
        },

        resetFilters() {
            this.statusFilter = null
            this.bootstrapFilter = null
            this.partnersValue = null
            this.audienceLabelValue = null
            this.audienceIdValue = null
            this.referenceIdValue = null
            this.resetDates()
        },

        resetDates() {
            this.dateFiltersVModelFromValues = {}
            this.dateFiltersVModelToValues = {}
            this.filterStartDate = cloneDeep(FILTERING_DEFAULT_DATES.start)
            this.filterEndDate = cloneDeep(FILTERING_DEFAULT_DATES.end)
            this.operators = {
                filterEndDate: 'equal',
                filterStartDate: 'equal'
            }
        },

        handleFromDate(filterKey, event) {
            this.dateFiltersVModelFromValues[filterKey] = event
            if (this.showFilterOnce) this.setSelectedTransferRowId(null)
        },

        handleToDate(filterKey, event) {
            this.dateFiltersVModelToValues[filterKey] = event
            if (this.showFilterOnce) this.setSelectedTransferRowId(null)
        },

        handleSelectionChange(val) {
            this.bulkSelectedRows = val
        },

        displayBulkEditForm(value, isDelete) {
            if (this.isUpdatedOrDeletedLoading) return
            this.isDeleteForm = isDelete
            this.setDisplayModal({ item: 'bulkEdit', display: value })
        },

        async clearSelection() {
            if (this.resetBulkSelectedRows) await this.resetEditBulkForm()
            this.$refs.tableData.clearSelection()
        },

        toggleFilter() {
            this.showFilters = !this.showFilters
            this.showFilterOnce = false
        },

        disabledpickerOptionsFromDate(time, key) {
            const filterFromEndDate = this.dateFiltersVModelFromValues.filterEndDate
            const filterFromStartDate = this.dateFiltersVModelFromValues.filterStartDate
            const filterToStartDate = this.dateFiltersVModelToValues.filterStartDate
            const filterToEndDate = this.dateFiltersVModelToValues.filterEndDate
            if (key === 'filterStartDate' && filterFromEndDate) {
                return time.getTime() > new Date(filterFromEndDate).getTime()
            } else if (key === 'filterStartDate' && filterToStartDate) {
                return time.getTime() > new Date(filterToStartDate).getTime()
            } else if (key === 'filterEndDate' && filterFromStartDate && filterToEndDate) {
                const start = time.getTime() < new Date(filterFromStartDate).getTime()
                const end = time.getTime() > new Date(filterToEndDate).getTime()
                return start || end
            } else if (key === 'filterEndDate' && filterFromStartDate) {
                return time.getTime() < new Date(filterFromStartDate).getTime()
            } else if (key === 'filterEndDate' && filterToEndDate) {
                return time.getTime() > new Date(filterToEndDate).getTime()
            } else if (key === 'filterStartDate') {
                return time.getTime() > Date.now()
            }
            return false
        },

        disabledpickerOptionsToDate(time, key) {
            const filterFromEndDate = this.dateFiltersVModelFromValues.filterEndDate
            const filterFromStartDate = this.dateFiltersVModelFromValues.filterStartDate
            if (key === 'filterStartDate' && filterFromStartDate) {
                return time.getTime() < new Date(filterFromStartDate).getTime() || time.getTime() > Date.now()
            } else if (key === 'filterStartDate') {
                return time.getTime() > Date.now()
            } else if (key === 'filterEndDate' && filterFromEndDate) {
                return time.getTime() < new Date(filterFromEndDate).getTime()
            }
            return false
        },

        changeOperator(key) {
            if (this.operators[key] === 'period' && this.dateFiltersVModelToValues[key]) this.dateFiltersVModelToValues[key] = ''
        },

        deleteTransferHandler() {
            this.setDisplayModal({ item: 'transfer', display: true })
            const audience = this.transferList.find(({ id }) => id === this.selectedTransferRowId)
            if(!isNil(audience)) {
                this.setDeletedTransfer({ transferId: this.selectedTransferRowId, audienceId: +audience.audience_id })
            }
        },

        exportDataForm(type) {
            this.setExportForm({
                display: true,
                type
            })
        },

        handleCommand(command) {
            if (command === 'transfer_export') {
                this.exportDataForm('transfer')
                return
            }
            if (command === 'delete') {
                this.deleteTransferHandler()
                return
            }
        },
        hasCpmOrReferenceId(row) {
            return this.hasCpm(row) || this.hasReferenceId(row)
        },
        hasCpm(row) {
            return !isNil(row.cpm)
        },
        hasReferenceId(row) {
            return !isEmpty(row.reference_id)
        },
        updateBulkListState(values) {
            this.bulkSelectedRows.forEach(row => {
                if (values.includes(row.id)) {
                    row.bootstrap_status = 'pending'
                }
            })
        }
    }
}
</script>
